<template>
  <div v-if="this.subscription && this.subscription.plan">
    <div class="container mobile-logo">
      <div class="row">
        <div class="col-md-12">
          <img class="mb-4" src="../../assets/img/logo.png" alt="Logo" width="200" height="110" />
        </div>
      </div>
    </div>
    <div class="container-fluid checkout-mobile">
      <div class="container">
        <div class="row checkout">
          <div class="col-lg-12 col-md-12 col-sm-12">
            <table>
              <tr style="cursor:pointer">
                <td class="cart-ico">
                  <i class="bi bi-cart3"></i>
                </td>
                <td v-on:click="mobileSummary">
                  <span v-if="!mobileSummaryActive"
                    >Show Order Summary
                    <i class="bi bi-caret-down-fill"></i>
                    
                  </span>
                  <span v-if="mobileSummaryActive">
                    Hide Order Summary
                    <i class="bi bi-caret-up-fill"></i>
                  </span>
                </td>
                <td class="price" v-if="this.subscription.products.length > 0">
                  {{ this.countrySetting.currencySymbol }}
                  {{ this.subscription.grandTotalInSelectedCurrency.toFixed(2) }}
                </td>
              </tr>
            </table>

            <transition name="fade">
              <div v-if="mobileSummaryActive">
                <div style="margin-top: 20px"></div>
                <div
                  class="alert alert-danger alert-dismissible fade show"
                  v-if="!this.coupon.isValid && this.coupon.message"
                  role="alert"
                >
                  {{ this.coupon.message }}
                </div>
                <div
                  class="alert alert-success alert-dismissible fade show"
                  v-if="this.coupon.isValid && this.coupon.message"
                  role="alert"
                >
                  {{ this.coupon.message }}
                </div>
                <div id="quantity-picker">
                  <span>Quantity</span> <br />
                  <div class="input-group">
                  <button id="btnDecreaseQuantity" type="button" class="btn btn-primary" v-on:click="decreaseQuantity()">
                    <i class="bi bi-dash-lg"></i></button>
                  <input type="text" style="text-align:center" class="form-control" disabled v-model="this.subscription.plan.quantity" />
                  <button id="btnIncreaseQuantity" type="button" class="btn btn-primary" v-on:click="increaseQuantity()">
                    <i class="bi bi-plus-lg"></i>
                  </button>
                  </div>
                </div>
                <CheckoutProducts
                  v-if="this.subscription.plan != null"
                  v-bind:plan="this.subscription.plan"
                  v-bind:products="this.subscription.products"
                  v-bind:currencySymbol="this.countrySetting.currencySymbol"
                ></CheckoutProducts>
                <div class="row discount-form discount-section">
                  <div class="input-group">
                    <input type="text" class="form-control" name="discount" placeholder="Coupon Code" v-model="this.selectedCouponCode" />
                    <button
                      id="btnApplyCoupon"
                      v-on:click="applyCoupon(this.selectedCouponCode, this.selectedPlan, this.selectedProducts)"
                      class="btn btn-outline-primary"
                      type="button"
                    >
                      Apply
                    </button>
                  </div>
                  
                </div>
                <CheckoutSummary
                  v-bind:subscription="subscription"
                  v-bind:currencySymbol="this.countrySetting.currencySymbol"
                ></CheckoutSummary>
              </div>
            </transition>
          </div>
        </div>
      </div>
      
    </div>
    <div class="container">
      <div class="row checkout">
        <div class="col-xl-7 col-lg-7 col-md-12 col-sm-12">
          <img class="mb-4 desktop-logo" src="../../assets/img/logo.png" alt="Logo" width="200" height="110" />
          <div id="paypal-button-container" class="paypal-box">
            <h4>Express Checkout</h4>
            <button class="paypal-button" v-on:click="goWithPaypal()">
              <img src="../../assets/img/paypal.svg" />
            </button>
            <p
              class="paypal-message"
              v-if="this.paypalExpress.payment_method && this.paypalExpress.payment_method.reference_id.length > 0"
            >
              Your paypal payment is confirmed. Fill up the form below and process the order.
            </p>
          </div>
          <h2 class="section-header">Contact Information</h2>
          <form class="checkout-form" v-on:submit.prevent>
            <div class="input-wrapper">
              <small class="input-error" v-if="this.validation.email.show">{{ this.validation.email.msg }}</small>
              <input
                type="text"
                name="email"
                v-model="customer.email"
                @change="this.validate('email')"
                placeholder="Email"
                class="form-control"
              />
            </div>
            <h2 class="section-header">Shipping Address</h2>
            <div class="row">
              <div class="col-lg-6">
                <div class="input-wrapper">
                  <small class="input-error" v-if="this.validation.firstName.show">{{
                    this.validation.firstName.msg
                  }}</small>
                  <input
                    autocapitalize="off"
                    spellcheck="false"
                    @change="this.validate('firstName')"
                    v-model="customer.firstName"
                    type="text"
                    name="firstName"
                    class="form-control"
                    placeholder="First Name"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-wrapper">
                  <small class="input-error" v-if="this.validation.lastName.show">{{
                    this.validation.lastName.msg
                  }}</small>
                  <input
                    autocapitalize="off"
                    spellcheck="false"
                    @change="this.validate('lastName')"
                    v-model="customer.lastName"
                    type="text"
                    class="form-control"
                    name="lastName"
                    placeholder="Last Name"
                  />
                </div>
              </div>
            </div>
            <div class="input-wrapper">
              <input
                autocapitalize="off"
                spellcheck="false"
                v-model="customer.companyName"
                type="text"
                name="company"
                class="form-control"
                placeholder="Company (Optional)"
              />
            </div>
            <div class="input-wrapper">
              <small class="input-error" v-if="this.validation.address.show">{{ this.validation.address.msg }}</small>
              <input
                autocapitalize="off"
                spellcheck="false"
                v-model="customer.address"
                @change="this.validate('address')"
                type="text"
                name="address"
                class="form-control"
                placeholder="Address"
              />
            </div>
            <div class="input-wrapper">
              <input
                autocapitalize="off"
                spellcheck="false"
                v-model="customer.apartment"
                @change="this.validate('apartment')"
                type="text"
                name="apartment"
                class="form-control"
                placeholder="Apartment, Suite, etc. (Optional)"
              />
            </div>
            <div class="row">
              <div id="country" :class="['col-sm-12', showStates ? 'col-lg-6 col-md-6' : 'col-lg-12 col-md-12']">
                <div class="input-wrapper">
                  <small class="input-error" v-if="this.validation.country.show">{{
                    this.validation.country.msg
                  }}</small>
                  <select name="country" v-model="customer.country" @change="countryChange()" class="form-select">
                    <option value="">Select Country</option>
                    <option :key="code" v-for="(name, code) in this.countries" v-bind:value="code">{{ name }}</option>
                  </select>
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="input-wrapper" v-if="this.showStates">
                  <small class="input-error" v-if="this.validation.stateCode.show">{{
                    this.validation.stateCode.msg
                  }}</small>
                  <select name="state" v-model="customer.stateCode" @change="stateChange()" class="form-select">
                    <option value="" selected>Select State</option>
                    <option :key="code" v-for="(name, code) in this.states" v-bind:value="code">{{ name }}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <div class="input-wrapper" v-if="customer.country !== 'AU'">
                  <small class="input-error" v-if="this.validation.city.show">{{ this.validation.city.msg }}</small>
                  <input
                    autocapitalize="off"
                    spellcheck="false"
                    @change="this.validate('city')"
                    v-model="customer.city"
                    type="text"
                    name="city"
                    class="form-control"
                    placeholder="City"
                  />
                </div>
                <div class="input-wrapper" v-if="customer.country === 'AU'">
                  <small class="input-error" v-if="this.validation.suburb.show">{{ this.validation.suburb.msg }}</small>
                  <input
                    autocapitalize="off"
                    spellcheck="false"
                    v-model="customer.suburb"
                    @change="this.validate('suburb')"
                    type="text"
                    class="form-control"
                    name="suburb"
                    placeholder="Suburb"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-wrapper">
                  <small class="input-error" v-if="this.validation.postalCode.show">{{
                    this.validation.postalCode.msg
                  }}</small>
                  <input
                    autocapitalize="off"
                    spellcheck="false"
                    @change="this.validate('postalCode')"
                    v-model="customer.postalCode"
                    type="text"
                    class="form-control"
                    name="postalCode"
                    placeholder="Postal Code"
                  />
                </div>
              </div>
            </div>

            <div class="input-wrapper">
              <small class="input-error" v-if="this.validation.phone.show">{{ this.validation.phone.msg }}</small>
              <input
                type="text"
                name="phone"
                @change="this.validate('phone')"
                v-model="customer.phone"
                class="form-control"
                placeholder="Phone"
              />
            </div>
            <!-- Shipping -->
            <h2 class="section-header">Shipping Method</h2>
            <div class="content-box">
              <p v-if="customer.country == ''">Enter your shipping address to see shipping options</p>
              <div class="row" v-if="customer.country != ''">
                <div class="col-lg-8 col-md-8 col-sm-7">
                  <input type="radio" checked="checked" />&nbsp;{{ subscription.selectedShippingOption.name }}
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4" style="text-align: right">
                  <span v-if="this.subscription.selectedShippingOption.price > 0"
                    >{{ this.countrySetting.currencySymbol
                    }}{{ this.subscription.selectedShippingOption.priceInSelectedCurrency }}</span
                  >
                  <span v-if="this.subscription.selectedShippingOption.price === 0">FREE</span>
                </div>
              </div>
            </div>

            <!-- Payment -->
            <div
              v-show="!this.paypalExpress.payment_method || this.paypalExpress.payment_method.reference_id.length === 0"
            >
              <h2 class="section-header">Payment Information</h2>
              <small>All transactions are secure and encrypted.</small>
              <div class="content-box">
                <div class="payment-box">
                  <div class="row">
                    <div class="col-lg-6">
                      <strong>Credit Card</strong><br />
                      <small
                        class="paypal-message"
                        v-if="
                          this.paypalExpress.payment_method && this.paypalExpress.payment_method.reference_id.length > 0
                        "
                        >You already paid with PayPal so no need to type your card details.</small
                      >
                    </div>
                    <div class="col-lg-6 card-list">
                      <img src="../../assets/img/visa.svg" />
                      <img src="../../assets/img/master.svg" />
                      <img src="../../assets/img/jcb.svg" />
                      <img src="../../assets/img/american.svg" />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-12" id="cardErrors"></div>
                  </div>
                  <div class="row">
                    <div class="col-lg-12" id="cardDetails"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="input-wrapper col-lg-4 col-sm-12 col-md-12">
              <input class="continue-button" type="submit" value="Process Order" v-on:click="processOrder()" />
            </div>
          </form>
          <CheckoutFooter></CheckoutFooter>
        </div>
        <div class="col-xl-1 col-lg-1 col-md-12 col-sm-12"></div>
        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 checkout-right-panel">
          <div
            class="alert alert-danger alert-dismissible fade show"
            v-if="!this.coupon.isValid && this.coupon.message"
            role="alert"
          >
            {{ this.coupon.message }}
          </div>
          <div class="alert alert-success alert-dismissible fade show" v-if="this.coupon.isValid" role="alert">
            Coupon <strong>{{ this.coupon.message }}</strong> is valid.
          </div>
          <div id="quantity-picker">
            <span>Quantity</span> <br />
            <div class="input-group">
            <button id="btnDecreaseQuantity" type="button" class="btn btn-primary" v-on:click="decreaseQuantity()">
              <i class="bi bi-dash-lg"></i></button>
            <input type="text" class="form-control text-center" disabled v-model="this.subscription.plan.quantity" />
            <button id="btnIncreaseQuantity" type="button" class="btn btn-primary" v-on:click="increaseQuantity()">
              <i class="bi bi-plus-lg"></i></button>
            
            </div>
          </div>
          <CheckoutProducts
            v-if="this.subscription.plan !== null"
            v-bind:plan="this.subscription.plan"
            v-bind:products="this.subscription.products"
            v-bind:currencySymbol="this.countrySetting.currencySymbol"
          ></CheckoutProducts>

          <div class="row discount-form discount-section">
            <div class="input-group">
              <input type="text" class="form-control" name="discount" placeholder="Coupon Code" v-model="this.selectedCouponCode" />
              <button
                id="btnApplyCoupon"
                v-on:click="applyCoupon(this.selectedCouponCode, this.selectedPlan, this.selectedProducts)"
                class="btn btn-outline-primary"
                type="button"
              >
                Apply
              </button>
            </div>
          </div>
          <CheckoutSummary
            v-bind:subscription="this.subscription"
            v-bind:currencySymbol="this.countrySetting.currencySymbol"
          ></CheckoutSummary>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { gofarService } from '../../helpers/gofar-service';
import { ENV, HTTP_METHODS, HTTP_STATUS_CODES, PAYMENTS, DEFAULT_SUBSCRIPTION_PLAN } from '../../helpers/config';
import * as chargebeeCheckout from '../../helpers/chargebee-checkout';
import { facade, filter, InputFacade } from 'vue-input-facade';
import { COUNTRIES, STATES } from '../../helpers/data/address-data-provider';
import * as StripeAPI from 'stripe';
import { spinnerOff, spinnerOn } from '../../helpers/animations';
import Swal from 'sweetalert2';
import CheckoutProducts from './components/CheckoutProducts';
import CheckoutSummary from './components/CheckoutSummary';
import CheckoutFooter from './components/CheckoutFooter';

export default {
  name: 'CheckoutForm',
  components: { CheckoutSummary, CheckoutFooter, InputFacade, CheckoutProducts },
  directives: { facade },
  filters: { facade: filter },
  data() {
    return {
      countries: COUNTRIES,
      states: STATES,
      showStatesSelector: false,
      mobileSummaryActive: false,
      products: [],
      subscriptions: [],
      shippingOptions: [],
      selectedPlan: '',
      selectedProducts: [],
      selectedQuantity: '1',
      selectedCouponCode: '',
      countrySetting: null,
      showStates: false,
      subscription: {
        products: [],
        plan: null,
        coupon: null,
        quantity: 1,
        selectedShippingOption: {
          name: '',
          price: 0.0
        },
        subTotal: 0.0,
        originalSubTotal: 0.0,
        grandTotal: 0.0
      },
      coupon: {
        code: '',
        discount_type: '',
        discount_amount: 0,
        currency_code: '',
        apply_discount_on: '',
        apply_on: '',
        plan_constraint: '',
        addon_constraint: '',
        plan_ids: [],
        addon_ids: [],
        isValid: false,
        message: '',
        parentCode: ''
      },
      customer: {
        email: '',
        firstName: '',
        lastName: '',
        companyName: '',
        address: '',
        apartment: '',
        stateCode: '',
        postalCode: '',
        suburb: '',
        city: '',
        country: '',
        currencyCode: '',
        phone: ''
      },
      validation: {
        email: { show: false, valid: false, msg: 'E-mail is required' },
        firstName: { show: false, valid: false, msg: 'First name is required' },
        lastName: { show: false, valid: false, msg: 'Last name is required' },
        address: { show: false, valid: false, msg: 'Address is required' },
        postalCode: { show: false, valid: false, msg: 'Post code is required' },
        city: { show: false, valid: false, msg: 'City is required' },
        country: { show: false, valid: false, msg: 'Country is required' },
        stateCode: { show: false, valid: false, msg: 'State is required' },
        suburb: { show: false, valid: false, msg: 'Suburb is required' },
        phone: { show: false, valid: false, msg: 'Phone is required' }
      },
      validForm: false,
      paypalExpress: {
        payment_method: {
          type: 'paypal_express_checkout',
          reference_id: ''
        }
      },
      stripeClient: null,
      stripeAPI: StripeAPI(PAYMENTS.STRIPE),
      card: null
    };
  },
  mounted() {
    let stripe = document.createElement('script');
    stripe.setAttribute('src', 'https://js.stripe.com/v3/');
    document.head.appendChild(stripe);

    const GTMSettings = chargebeeCheckout.getGTMSettings(ENV);

    let gtmChargebee = document.createElement('script');
    gtmChargebee.src = 'https://js.chargebee.com/v2/chargebee.js';
    gtmChargebee.setAttribute('data-cb-site', GTMSettings.site);
    gtmChargebee.setAttribute('data-cb-gtm-enabled', 'true');
    document.head.appendChild(gtmChargebee);

    const stripeMounter = () => {
      try {
        if (document.getElementById('cardDetails') === null) {
          return;
        }
        this.stripeClient = Stripe(PAYMENTS.STRIPE);
        this.cardElement = this.stripeClient.elements().create('card', {
          iconStyle: 'solid',
          style: {
            base: {
              iconColor: '#c4f0ff',
              color: '#000',
              fontWeight: 500,
              fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
              fontSize: '16px',
              fontSmoothing: 'antialiased',

              ':-webkit-autofill': {
                color: '#fce883'
              },
              '::placeholder': {
                color: '#87BBFD'
              }
            },
            invalid: {
              iconColor: '#FFC7EE',
              color: '#f50f1e'
            }
          }
        });
        this.cardElement.mount('#cardDetails');
        this.cardElement.on('change', function (event) {
          var displayError = document.getElementById('cardErrors');
          if (event.error) {
            displayError.textContent = event.error.message;
          } else {
            displayError.textContent = '';
          }
        });
        clearInterval(tryMount);
      } catch (err) {
        // do nothing just try again finally it will be mounted.
      }
    };
    const tryMount = setInterval(stripeMounter, 1);
  },
  async created() {
    this.selectedPlan = this.$route.query.plan || DEFAULT_SUBSCRIPTION_PLAN;
    this.selectedProducts = this.$route.query.products ? this.$route.query.products.split(',') : [];
    this.selectedCouponCode = this.$route.query.coupon_code || '';
    this.customer.country = this.$route.query.country_code ? this.$route.query.country_code.toUpperCase() : 'AU';
    this.selectedQuantity = Math.ceil(Math.abs(this.$route.query.quantity)) || '1';
    this.showStates = Object.keys(STATES).includes(this.customer.country);
    this.states = STATES[this.customer.country];
    this.countrySetting = chargebeeCheckout.getCountrySetting(this.customer.country);
    this.coupon = await chargebeeCheckout.validateCouponCode(
      this.selectedCouponCode,
      this.selectedPlan,
      this.selectedProducts
    );
    await this.loadItems();
    this.subscription = chargebeeCheckout.mapToSubscriptionCheckout(
      this.selectedProducts,
      this.products,
      this.selectedPlan,
      this.plans,
      this.subscription,
      this.shippingOptions,
      this.coupon,
      this.countrySetting,
      this.selectedQuantity
    );
    this.mountPaypal(this.countrySetting.currencyCode);

    window.dataLayer.push({ pagePostType: 'page', pageCategory: ['chargebee-checkout'] });
  },
  methods: {
    validate: function (key) {
      if (!this.validation[key]) {
        return;
      }


      if (key === 'stateCode') {
        const states = STATES[this.customer.country];
        if (states && Object.keys(states).length > 0 && !this.customer[key]) {
          this.validation[key].valid = false;
          this.validation[key].show = true;
        } else {
          this.validation[key].valid = true;
          this.validation[key].show = false;
        }
      } else if (key === 'suburb') {
        if (this.customer.country === 'AU' && this.customer[key].trim().length === 0) {
          this.validation[key].valid = false;
          this.validation[key].show = true;
        } else {
          this.validation[key].valid = true;
          this.validation[key].show = false;
        }
      } else if (key === 'city'){
        if (this.customer.country != 'AU' && this.customer[key].trim().length === 0) {
          this.validation[key].valid = false;
          this.validation[key].show = true;
        } else {
          this.validation[key].valid = true;
          this.validation[key].show = false;
        }
      } else if(key === 'email' && this.customer[key].trim().length > 0){
        const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        if(!emailRegex.test(this.customer[key])){
          this.validation[key].valid = false;
          this.validation[key].msg = "Email format is incorrect";
          this.validation[key].show = true;
        }else{
          this.validation[key].msg = "E-mail is required";
          this.validation[key].valid = true;
          this.validation[key].show = false;
        }
      }
       else {
        this.validation[key].show = this.customer[key].trim().length === 0;
        this.validation[key].valid = this.customer[key].trim().length > 0;
      }
    },
    validateForm: function () {
      for (const key of Object.keys(this.validation)) {
        this.validate(key);
      }
      this.validForm = Object.keys(this.validation).filter((key) => !this.validation[key].valid).length === 0;
    },
    countryChange: function () {
      this.customer.stateCode = '';
      this.showStates = Object.keys(STATES).includes(this.customer.country);
      this.states = STATES[this.customer.country];

      this.countrySetting = chargebeeCheckout.getCountrySetting(this.customer.country);
      this.subscription = chargebeeCheckout.mapToSubscriptionCheckout(
        this.selectedProducts,
        this.products,
        this.selectedPlan,
        this.plans,
        this.subscription,
        this.shippingOptions,
        this.coupon,
        this.countrySetting,
        this.selectedQuantity
      );
      this.validate('country');
    },
    stateChange: function () {
      if (this.customer.country && this.customer.stateCode) {
        this.customer.state = STATES[this.customer.country][this.customer.stateCode];
      }
      this.validate('stateCode');
    },
    loadItems: async function () {
      [this.products, this.plans, this.shippingOptions] = await chargebeeCheckout.getChargebeeItems();
    },
    mountPaypal: function () {
      const currencyCode = this.countrySetting.currencyCode;
      let paypal = document.createElement('script');
      paypal.setAttribute(
        'src',
        `https://www.paypal.com/sdk/js?client-id=${PAYMENTS.PAYPAL_MERCHANT_ID}&currency=${currencyCode}`
      );
      document.head.appendChild(paypal);
    },
    goWithPaypal: function () {
      const currencyCode = this.countrySetting.currencyCode;
      window.dataLayer.push({
        event: 'paypal_start'
      });
      var paypalWindow = window.open(
        `${process.env.VUE_APP_GOFAR_SERVICE_URL}/api/checkout/paypal?currency=${currencyCode}`,
        'GOFAR - Paypal'
      );

      window.addEventListener(
        'message',
        async (e) => {
          if (e.origin.includes(process.env.VUE_APP_GOFAR_SERVICE_URL)) {
            this.paypalExpress.payment_method.reference_id = decodeURI(e.data.billingAgreementId);
            paypalWindow.close();
            await this.fetchPaypalCustomerData(this.paypalExpress.payment_method.reference_id);
            this.countryChange();
            this.validateForm();
            window.dataLayer.push({
              event: 'paypal_finished'
            });
          }
        },
        false
      );
    },
    fetchPaypalCustomerData: async function (billingAgreementId) {
      this.customer = await chargebeeCheckout.fetchPaypalCustomerDetail(billingAgreementId, this.customer);
    },
    mobileSummary: function () {
      this.mobileSummaryActive = !this.mobileSummaryActive;
    },
    applyCoupon: async function (selectedCouponCode, selectedPlan, selectedProducts) {
      this.coupon = await chargebeeCheckout.validateCouponCode(selectedCouponCode, selectedPlan, selectedProducts);
      this.subscription = chargebeeCheckout.mapToSubscriptionCheckout(
        this.selectedProducts,
        this.products,
        this.selectedPlan,
        this.plans,
        this.subscription,
        this.shippingOptions,
        this.coupon,
        this.countrySetting,
        this.selectedQuantity
      );
      window.dataLayer.push({
        couponCode: selectedCouponCode,
        event: 'coupon_applied'
      });
    },
    increaseQuantity: function () {
      let quantity = parseInt(this.subscription.plan.quantity, 10);
      quantity += 1;
      this.subscription = chargebeeCheckout.mapToSubscriptionCheckout(
        this.selectedProducts,
        this.products,
        this.selectedPlan,
        this.plans,
        this.subscription,
        this.shippingOptions,
        this.coupon,
        this.countrySetting,
        quantity
      );
      this.selectedQuantity = this.subscription.plan.quantity;
    },
    decreaseQuantity: function () {
      let quantity = parseInt(this.subscription.plan.quantity, 10);
      quantity -= 1;
      if (quantity < 1) {
        quantity = 1;
      }
      this.subscription = chargebeeCheckout.mapToSubscriptionCheckout(
        this.selectedProducts,
        this.products,
        this.selectedPlan,
        this.plans,
        this.subscription,
        this.shippingOptions,
        this.coupon,
        this.countrySetting,
        quantity
      );
      this.selectedQuantity = this.subscription.plan.quantity;
    },
    processPayment: async function () {
      // Step 1 - Create payment intent
      const stripeResponse = await gofarService('/api/checkout/stripe', HTTP_METHODS.POST, {
        /**
         * make sure that the grand total adds up to the total cost of plan, products (add-ons) and shipping cost (add-on but named as shipping cost for brevity)
         * if the grandtotal payment made in stripe doesn't add up then it won't create subscription in chargebee due to amount difference
         * ? currency will always be in AUD at the moment unless and until we move to PC2 and enable multi currency feature
         */
        amount: this.subscription.grandTotal,
        currency: 'AUD',
        email: this.customer.email,
        firstName: this.customer.firstName,
        lastName: this.customer.lastName
      });

      if (!stripeResponse.data.client_secret) {
        Swal.fire({
          icon: 'error',
          title: 'Payment Error',
          text: 'Oops! We could not process your payment. Please contact us at support@gofar.co.',
          footer: ''
        });
        return;
      }

      const clientSecret = stripeResponse.data.client_secret;

      // Step 2 - Confirm card payment
      spinnerOn(); // It can take a while so turn on spinner in here
      const payment = await this.stripeClient.confirmCardPayment(clientSecret, {
        payment_method: {
          card: this.cardElement
        }
      });
      return payment;
    },
    addProductsToDataLayer: function (subscriptionId) {
      window.dataLayer.push({
        event: 'transaction',
        ecommerce: {
          purchase: {
            actionField: {
              id: subscriptionId,
              affiliation: 'Chargebee checkout',
              coupon: this.subscription.coupon,
              shipping: `${this.subscription.selectedShippingOption.price}`,
              revenue: `${this.subscription.grandTotal / 100}`
            },
            products: this.products.map((product) => {
              return {
                name: product.name,
                id: product.id,
                price: `${product.price}`,
                quantity: product.quantity,
                currency: product.currency
              };
            })
          }
        }
      });
    },
    processOrder: async function () {
      try {
        this.validateForm();
        if (!this.validForm) {
          return;
        }
        spinnerOn();
        // Block button for 5s
        this.validForm = false;
        setTimeout(() => {
          this.validForm = true;
        }, 5000);
        let paymentData = {};
        let payment = {};
        if (!this.paypalExpress.payment_method || this.paypalExpress.payment_method.reference_id.length === 0) {
          payment = await this.processPayment();
          if (payment.error) {
            Swal.fire({
              icon: 'error',
              title: 'Payment Error',
              text: payment.error.message,
              footer: ''
            });
          }
          if (payment.paymentIntent && payment.paymentIntent.status !== 'requires_capture') {
            throw new Error(payment.error.message);
          }
          paymentData = {
            gw_token: payment.paymentIntent.id,
            gateway_account_id: process.env.VUE_APP_STRIPE_GW
          };
          // Remove paypal if user pay by card
          this.paypalExpress = {};
        }

        const subscription_result = await chargebeeCheckout.createSubscription(
          this.customer,
          this.subscription,
          this.coupon,
          paymentData,
          this.paypalExpress
        );
        this.validForm = true;
        if (subscription_result.status !== HTTP_STATUS_CODES.SUCCESS) {
          spinnerOff();
          this.addProductsToDataLayer();
          Swal.fire({
            icon: 'error',
            title: 'Cannot create subscription',
            html: `Oops! We could not process your payment. Please contact us at support@gofar.co.`,
            footer: `Error details (please provide those): ${subscription_result.data.error}`
          });
          if (payment.paymentIntent) {
            // If cannot create subscription then cancel blocked money on card immediately
            await gofarService(`/api/checkout/stripe-cancel?id=${payment.paymentIntent.id}`, 'POST');
          }
        } else {
          // Must be separate page because of GA Tracking
          localStorage.setItem('chargebee_subscription', JSON.stringify(subscription_result.data));
          localStorage.setItem('subscription', JSON.stringify(this.subscription));
          localStorage.setItem('customer', JSON.stringify(this.customer));
          this.$router.push({
            path: '/checkout-finish',
            query: { order_id: subscription_result.data.subscription.id }
          });
        }
      } catch (err) {
        Swal.fire({
          icon: 'error',
          title: 'Payment Error',
          text: err.error?.message,
          footer: ''
        });
      } finally {
        spinnerOff();
      }
    }
  }
};
</script>
